<app-main-layout>
  <app-championship-form-page></app-championship-form-page>
</app-main-layout>
